import React from "react";

function TableOfContents({ items, activeId }) {
  if (!items?.length) {
    return null;
  }

  return (
    <nav className="toc" aria-label="Оглавление статьи">
      <p className="toc__title">Оглавление</p>
      <ul className="toc__list">
        {items.map((item) => (
          <li
            className={`toc__item toc__item--level${item.level}`}
            key={item.id}
          >
            <a
              className={`toc__link${activeId === item.id ? " active" : ""}`}
              href={`#${item.id}`}
              aria-current={activeId === item.id ? "location" : undefined}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default TableOfContents;
